import React from 'react'
import { OrderFragment_order_products, CartFragment_cart_products } from 'Utils/api/gql/types';
import { GiftInfo, isGiftInfo } from 'Components/ProductQuantityInput/GiftCardInput';
import cl from './GiftMessage.scss'
import cn from 'classnames'
import cg from 'Scss/app.scss'
import { SVGProdGift } from 'Components/SVGCollection';

const GiftMessage: React.FunctionComponent<{ cartProduct: CartFragment_cart_products | OrderFragment_order_products }> = ({ cartProduct }) => {
    if (!cartProduct.additional_information) {
        return null
    }
    
    let giftInfo: GiftInfo | null = null
    try {
        giftInfo = JSON.parse(cartProduct.additional_information)
        if (!isGiftInfo(giftInfo)) {
            return null
        }
    } catch (e) { 
        return null
    }

    return (
        <div className={cn(cg.gridX, cg.alignMiddle, cl.prodGift)} title={giftInfo.giftCardText}>
            <div className={cn(cg.cell, cl.prodGiftIcon)}>
                <SVGProdGift />
            </div>
            <div className={cn(cg.cell, cl.prodGiftText)}>
                {giftInfo.color}, <span>{giftInfo.giftCardText}</span>
            </div>
        </div>
    )

}

export default GiftMessage
